import React from 'react';
import {KTMScreen,ActionEvent,RenderEvent,renderScreen} from 'ktm-ui';
import {KTMApi} from 'api/KTMApi';
import {Layout,Dialog,Button,Display,Card} from 'ktm-ui';

interface IdsCostCentre {
    Id:string;
    Policy_Id:string;
    Name:string;
    Description:string;
    IsActive:boolean;
};

export default KTMScreen({name:"enroll.cost-centre.edit"}, class extends React.Component<{costcentre_id:string}> {

    data:{
        dsCostCentre:IdsCostCentre;
    }
    // Store original data for comparison
    originalData: IdsCostCentre | null = null;

    render(){
        return renderScreen(this);
    }

    async start({screen}:ActionEvent){
        screen.defaultRecord = "@dsCostCentre";
        await KTMApi.start(screen,{
            "@costcentre_id":this.props.costcentre_id,
        });
        screen.title = "Edit Cost Centre";
        // Store a copy of the original data
        this.originalData = { ...this.data.dsCostCentre };
    }

    main({field,draw,action}:RenderEvent){
        return (
            <Layout>
                {draw(this.header)}
                {draw(this.details)}
                {draw(this.footer)}
            </Layout>
        );
    }

    header({field,draw,action}:RenderEvent){
        return (
            <Dialog.Header label="Add Cost Centre"/>
        );
    }

    footer({field,draw,action}:RenderEvent){
        var isDisabled = this.data.dsCostCentre.Name == null || 
        this.data.dsCostCentre.Name == "" ||
        this.data.dsCostCentre.Description == null ||
        this.data.dsCostCentre.Description == "";
        return (
            <Dialog.Footer>
                <Button action={action(this.submit)} label="Save" size="large" style="primary" disable = {isDisabled}/>
            </Dialog.Footer>
        );
    }

    details({field,draw,action}:RenderEvent){
        return (
            <Card>
                <Display field={field("Name")}/>
                <Display field={field("Description")}/>
            </Card>
        );
    }

    getChangedFields(originalData, updatedData) {
        if (!originalData) return {};
  
        const changes = {};
        for (const key in updatedData) {
          if (updatedData[key] !== originalData[key]) {
            changes[key] = {
              oldValue:
                originalData[key] !== undefined ? originalData[key] : "N/A",
              newValue: updatedData[key] !== undefined ? updatedData[key] : "N/A",
            };
          }
        }
        return changes;
    }

    async submit({screen}:ActionEvent){
        // Track changes
        const changes = this.getChangedFields(
            this.originalData,
            this.data.dsCostCentre
        );

        const logDetails = Object.entries(changes)
            .map(([key, value]) => {
            const change = value as { oldValue: any; newValue: any };
            return `${key}: ${change.oldValue} → ${change.newValue}`;
            })
            .join(" | ");

        const policyLogs = {
            method: "PUT",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({
            Note: logDetails,
            Action: "Policy Edit Cost Centre",
            PolicyId: this.data.dsCostCentre.Policy_Id,
            }),
        };
        await KTMApi.action(screen,"submit",{
            "@dsCostCentre.Name":this.data.dsCostCentre.Name,
            "@dsCostCentre.Description":this.data.dsCostCentre.Description,
            "@dsCostCentre.IsActive":this.data.dsCostCentre.IsActive,
            "@costcentre_id":this.props.costcentre_id,
        }).then(() => {
            fetch("/api/PlanAdmin/updatepolicylogs", policyLogs);
        });
        screen.close({"continue":true});
    }

});
